<script lang="ts">
    import { tick } from 'svelte';

    interface Props {
        isIOSApp: boolean;
        cacheRestored: boolean;
        restoreScrollPosition: () => Promise<void>;
    }

    const { isIOSApp, cacheRestored, restoreScrollPosition }: Props = $props();

    /**
 *
 *
 *
 *
 *
 */

    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    $effect(() => {
        if (isIOSApp) {
            window.history.scrollRestoration = 'manual';
            if (cacheRestored) {
                tick().then(() => {
                    timeoutId = setTimeout(restoreScrollPosition, 250);
                });
            }
            return () => {
                window.history.scrollRestoration = 'auto';
                if (timeoutId !== undefined) {
                    clearTimeout(timeoutId);
                    timeoutId = undefined;
                }
            };
        }
    });
</script>
